<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Tidak ada data barang retur.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }} <span v-if="row.item.year != null">({{ row.item.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    {{ row.item.no_faktur }}
                    <div class="small text-muted">
                        {{ row.item.imei_sn }}<br />
                        Grade <strong>{{ row.item.grade }} - {{ row.item.spec }}</strong>
                    </div>
                </template>
                <template v-slot:cell(refund)="row">
                    Rp. {{ $helper.formatThousand(row.item.price) }}
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        returnId: { type: Number, required: true }
    },
    data() {
        return {

            initStatus: 0,
            isBusy: false,
            isSubmitting: false,
            show: 10,

            filter: {
                type: -1,
                startDate: "",
                endDate: ""
            },

            fields: [
                { key: "barang", label: "Barang", sortable: true },
                { key: "noFakturImei", label: "No. Faktur & IMEI / SN", sortable: true },
                { key: "refund", label: "Refund", sortable: true },
                { key: "reason", label: "Alasan Retur", sortable: true },
            ],

            items: [],
            
            sortBy: null,
            sortDesc: false,

        }
    },
    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getItems() {
            let param = ""
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "?sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }
            return this.$axios.get("returns/" + this.returnId + param).then(res => {
                this.items = res.data.data
            })
        }

    },
    created() {
        this.init()
    }
}
</script>
